module.exports = __webpack_public_path__ + "img/人脸.370aec16.png";